import { Area } from "../../typings/Area";
import { Endpoint } from "../../typings/endpoints";
import http from "../../utils/http";

const areasApi = {
  getAreas: async (): Promise<Area[]> => {
    const response = await http.get<Area[]>(Endpoint.AreaList);
    return response.data; 
  },
};

export default areasApi;
